// import React, { useEffect } from 'react'
// import ExhibitionGrid from './ExhibitionGrid'
// import Footer from '../HomePage/Footer.js'
// import StayConnected from '../AboutUs/StayConnected.js'
// import EventBanner from './EventBanner.js'
// import Navbar from '../HomePage/Navbar.js'
// import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup.js'
// import { useDispatch } from 'react-redux'
// import { openVolunteerPopup } from '../features/volunteerPopupSlice.js'
// import HalfBanner from '../HomePage/HalfBanner.js'
// import StayConnectedSocialIcons from './StayConnectedSocialIcons.js'
// import EventSliders from './EventSliders.js'
// import EventSlidersTwo from './EventSlidersTwo.js'
// import ContactusBanner from '../ContactUs/ContactusBanner.js'
// export default function EventMainPage() {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const shown = sessionStorage.getItem("volunteerPopupShown");
//     console.log("shown", shown)
//     if (!shown) {

//       const timer = setTimeout(() => {
//         dispatch(openVolunteerPopup());
//         sessionStorage.setItem("volunteerPopupShown", "true");
//       }, 3000);

//       return () => clearTimeout(timer);
//     }
//   }, [dispatch]);
//   return (
//     <div>

//       <VolunteerFormPopup />
//       <ContactusBanner />
//       <EventSliders />
//       <StayConnectedSocialIcons />
//       <Footer />
//     </div>
//   )
// }

import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom' // Import this
import { useDispatch } from 'react-redux'
import { openVolunteerPopup } from '../features/volunteerPopupSlice.js'

// Component Imports
import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup.js'
import ContactusBanner from '../ContactUs/ContactusBanner.js'
import EventSliders from './EventSliders.js'
import StayConnectedSocialIcons from './StayConnectedSocialIcons.js'
import Footer from '../HomePage/Footer.js'

export default function EventMainPage() {
  const dispatch = useDispatch();
  const { title } = useParams(); // Get the slug from /engagement/:title

  // Your dummy data array
  const data = [
    {
      title: "Festivities",
      para: "At Veer Samyak Foundation, we celebrate the spirit of togetherness through vibrant cultural festivals. These gatherings are more than just events; they are moments where our children and community find joy, belonging, and a shared sense of heritage.",
      image: [
        { order: 4, url: "/images/event_4.webp" },
        { order: 5, url: "/images/event_5.webp" },
        { order: 6, url: "/images/event_6.webp" },
        { order: 7, url: "/images/event_7.webp" },
        { order: 8, url: "/images/event_8.webp" },
        { order: 9, url: "/images/event_9.webp" },
        { order: 10, url: "/images/event_10.webp" },
        { order: 11, url: "/images/event_11.webp" },
        { order: 12, url: "/images/event_12.webp" },
        { order: 13, url: "/images/event_13.webp" },
        { order: 14, url: "/images/event_14.webp" },
        { order: 15, url: "/images/event_15.webp" },
        { order: 16, url: "/images/event_16.webp" },
        { order: 17, url: "/images/event_17.webp" },
        { order: 18, url: "/images/event_18.webp" },
        { order: 19, url: "/images/event_19.webp" },
        { order: 20, url: "/images/event_20.webp" },
        { order: 21, url: "/images/event_21.webp" },
        { order: 22, url: "/images/event_22.webp" },
        { order: 23, url: "/images/event_23.webp" },
        { order: 24, url: "/images/event_24.webp" },
        { order: 25, url: "/images/event_25.webp" },
        { order: 26, url: "/images/event_26.webp" },
        { order: 27, url: "/images/event_27.webp" },
        { order: 28, url: "/images/event_28.webp" },
        { order: 29, url: "/images/event_29.webp" },
        { order: 30, url: "/images/event_30.webp" },
        { order: 31, url: "/images/event_31.webp" },
        { order: 32, url: "/images/event_32.webp" },
        { order: 33, url: "/images/event_33.webp" },
        // { order: 34, url: "/images/event_34.webp" },
        { order: 35, url: "/images/event_35.webp" },
        { order: 36, url: "/images/event_36.webp" },
        { order: 37, url: "/images/event_37.webp" },
        { order: 38, url: "/images/event_38.webp" },

      ]
    },
    {
      title: "Enrichment Programs",
      para: "Building hope beyond limits starts with empowerment. Our enrichment programs focus on skill-building, mental well-being, and personal growth, ensuring that every individual has the tools to forge a future defined by dignity and self-reliance.",
       image: [
        { order: 2, url: "/images/event_2.webp" },
        { order: 3, url: "/images/event_3.webp" },
        { order: 5, url: "/images/event_5.webp" },
        { order: 6, url: "/images/event_6.webp" },
        { order: 7, url: "/images/event_7.webp" },
        { order: 8, url: "/images/event_8.webp" },
        { order: 9, url: "/images/event_9.webp" },
        { order: 10, url: "/images/event_10.webp" },
        { order: 11, url: "/images/event_11.webp" },
        { order: 12, url: "/images/event_12.webp" },
        { order: 13, url: "/images/event_13.webp" },

      ]
    },
    {
      title: "Excursions",
      para: "We believe that healing happens through discovery. Our guided excursions take children and families beyond their daily environments, opening their eyes to the beauty of the world and providing restorative experiences that strengthen the human spirit.",
       image: [
         { order: 1, url: "/images/event_14.webp" },
        { order: 2, url: "/images/event_15.webp" },
        { order: 3, url: "/images/event_16.webp" },
        
        { order: 8, url: "/images/event_8.webp" },
        { order: 4, url: "/images/event_17.webp" },
        { order: 5, url: "/images/event_18.webp" },
        { order: 6, url: "/images/event_19.webp" },
        { order: 7, url: "/images/event_20.webp" },
        { order: 8, url: "/images/event_21.webp" },
        { order: 9, url: "/images/event_22.webp" },
        { order: 10, url: "/images/event_23.webp" },

      ]
    },
    {
      title: "Expressions",
      para: "“Expressions” is our platform for the silent voice of the soul. Through art, music, and performance, we encourage those we serve to share their journey and resilience, turning their experiences into powerful testimonies of hope and transformation.",
       image: [
   { order: 1, url: "/images/event_22.webp" },
        { order: 2, url: "/images/event_23.webp" },
        { order: 3, url: "/images/event_24.webp" },
        { order: 4, url: "/images/event_25.webp" },
        { order: 5, url: "/images/event_26.webp" },
        { order: 6, url: "/images/event_27.webp" },
        { order: 7, url: "/images/event_28.webp" }
      ]
    }
  ];

  // Helper function to match the slug
  const createSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, "-");
  };

  // Find the specific object where the slugified title matches the URL param
  const activeEvent = data.find(item => createSlug(item.title) === title);

  // useEffect(() => {
  //   const shown = sessionStorage.getItem("volunteerPopupShown");
  //   if (!shown) {
  //     const timer = setTimeout(() => {
  //       dispatch(openVolunteerPopup());
  //       sessionStorage.setItem("volunteerPopupShown", "true");
  //     }, 3000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [dispatch]);

  // If no match is found, you can show a 404 or a loader
  if (!activeEvent) {
    return <div className="text-center p-5">Event not found</div>;
  }

  return (
    <div>
      <VolunteerFormPopup />

      {/* Passing the matched title to the Banner */}
      <ContactusBanner title={activeEvent.title} description={activeEvent.para} />

      {/* Passing the matched data to your Slider/Content component */}
      <EventSliders
        key={title}  
        PHOTOS={activeEvent.image}
      />

      {/* <StayConnectedSocialIcons /> */}
      <Footer />
    </div>
  )
}